import api from "./api";

export const getFacilities = async () => {
  return api
    .get({
      endpoint: "/facility",
      port: process.env.REACT_APP_PORT_FACILITY,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
